import type { FaireProductEntity } from "../../entity_types/product";

export const p_rcdg87t7ya: FaireProductEntity = {
  token: "p_rcdg87t7ya",
  type: "product",
  name: "Mixed Florals Drying Mat",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/3303ef684748e4d88d3ad29a9e5a287a4a0d05856a040106454b32a1f08e6c25.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79ebca3f65f86521e53056aa098f5f5c775e812604398f7eed4020cda1042e1e.jpeg",
    "https://cdn.faire.com/fastly/d602c3c808394cfc4f64cd3f910bdc6327b5ba494ffc0869c2acb3f2936c2fa3.jpeg",
    "https://cdn.faire.com/fastly/a1719a20fff837b5d945f4f3844440993d40a0e8f6b7f1884fadf9c2a2eac0ef.jpeg",
    "https://cdn.faire.com/fastly/5f7057d7811e1e84dde05ccf601755876fdaaa90e69290071b9327aa8c34f6cb.jpeg"
  ],
  priceDollars: 5,
  description: "An ultra-absorbent drying mat from our Garden Collection displaying a colorful pattern of mixed florals replicated from original art hand painted in a delicate watercolor style. This floral drying mat features a full color design on the 21 inch by 14 inch space to place items for drying with a coordinating pink color on the back and trim. Our Mixed Florals drying mat includes a hanger at the top to display the design or to air dry when not in use. Kitchen drying mat is conveniently machine-washable for easy cleaning and folds up for easy storage. A stylish botanical kitchen accessory perfect for everyday use.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:08.773Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
